import { Box } from "@mui/material";
import { resolveAssetUrl } from "utils/media";

const UserImage = ({ image, size = "60px" }) => {
  return (
    <Box width={size} height={size}>
      <img
        style={{ objectFit: "cover", borderRadius: "50%" }}
        width={size}
        height={size}
        alt="user"
        src={resolveAssetUrl(image)}
      />
    </Box>
  );
};

export default UserImage;
